import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { getAuth } from "./matuAuth";
import { getDatabase, ref, get } from "./matuRtdb";
import PropTypes from "prop-types";

const SuperAdminRoute = ({ element: Element }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [error, setError] = useState(null);
  const [debugInfo, setDebugInfo] = useState(null);

  useEffect(() => {
    const checkSuperAdminStatus = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;

        console.log("🔍 Verificando Super Admin...");
        console.log("Usuario actual:", user);
        console.log("🔑 userUUID en localStorage:", localStorage.getItem("userUUID"));
        console.log("🔑 uid en localStorage:", localStorage.getItem("uid"));

        if (!user) {
          console.log("❌ No hay usuario autenticado en Firebase Auth");
          console.log("🔍 Verificando si hay UID en localStorage...");
          
          const storedUID = localStorage.getItem("userUUID") || localStorage.getItem("uid");
          if (storedUID) {
            console.log("✅ Encontrado UID en localStorage:", storedUID);
            // Intentar verificar con el UID almacenado
            const db = getDatabase();
            const userRef = ref(db, `usuarios/${storedUID}`);
            console.log(`🔍 Buscando en: usuarios/${storedUID}`);
            
            const snapshot = await get(userRef);
            
            if (snapshot.exists()) {
              const userData = snapshot.val();
              console.log("📊 Datos del usuario encontrados:", userData);
              console.log("🔑 isSuperAdmin value:", userData.isSuperAdmin);
              console.log("🔑 Tipo de isSuperAdmin:", typeof userData.isSuperAdmin);
              
              setDebugInfo({
                uid: storedUID,
                userData: userData,
                isSuperAdminValue: userData.isSuperAdmin,
                isSuperAdminType: typeof userData.isSuperAdmin,
                foundPath: `usuarios/${storedUID}`,
                authStatus: "No autenticado en Firebase, pero UID encontrado en localStorage"
              });

              const hasSuperAdmin = userData.isSuperAdmin === true || 
                                   userData.isSuperAdmin === "true" || 
                                   userData.isSuperAdmin === 1 ||
                                   userData.isSuperAdmin === "1" ||
                                   userData.isSuperAdmin === "yes" ||
                                   userData.isSuperAdmin === "YES";
              
              console.log("✅ ¿Tiene Super Admin?", hasSuperAdmin);
              setIsSuperAdmin(hasSuperAdmin);
            } else {
              console.log("❌ Usuario no encontrado en usuarios/");
              
              // Intentar en BetPay como respaldo
              const betpayRef = ref(db, `BetPay/${storedUID}`);
              console.log(`🔍 Intentando en BetPay: BetPay/${storedUID}`);
              
              const betpaySnapshot = await get(betpayRef);
              
              if (betpaySnapshot.exists()) {
                const userData = betpaySnapshot.val();
                console.log("📊 Datos del usuario encontrados en BetPay:", userData);
                console.log("🔑 isSuperAdmin value:", userData.isSuperAdmin);
                
                setDebugInfo({
                  uid: storedUID,
                  userData: userData,
                  isSuperAdminValue: userData.isSuperAdmin,
                  isSuperAdminType: typeof userData.isSuperAdmin,
                  foundPath: `BetPay/${storedUID}`,
                  authStatus: "No autenticado en Firebase, pero UID encontrado en localStorage"
                });

                const hasSuperAdmin = userData.isSuperAdmin === true || 
                                     userData.isSuperAdmin === "true" || 
                                     userData.isSuperAdmin === 1 ||
                                     userData.isSuperAdmin === "1" ||
                                     userData.isSuperAdmin === "yes" ||
                                     userData.isSuperAdmin === "YES";
                
                console.log("✅ ¿Tiene Super Admin?", hasSuperAdmin);
                setIsSuperAdmin(hasSuperAdmin);
              } else {
                console.log("❌ Usuario no encontrado en ninguna ubicación");
                setDebugInfo({
                  uid: storedUID,
                  userData: null,
                  isSuperAdminValue: null,
                  isSuperAdminType: null,
                  foundPath: null,
                  authStatus: "No autenticado en Firebase, UID en localStorage pero no encontrado en DB"
                });
                setIsSuperAdmin(false);
              }
            }
          } else {
            console.log("❌ No hay UID almacenado en localStorage");
            setDebugInfo({
              uid: null,
              userData: null,
              isSuperAdminValue: null,
              isSuperAdminType: null,
              foundPath: null,
              authStatus: "No autenticado en Firebase y no hay UID en localStorage"
            });
            setIsSuperAdmin(false);
          }
          setIsLoading(false);
          return;
        }

        const db = getDatabase();
        
        // Buscar en la ruta principal de usuarios
        const userRef = ref(db, `usuarios/${user.uid}`);
        console.log(`🔍 Buscando en: usuarios/${user.uid}`);
        
        const snapshot = await get(userRef);
        
        if (snapshot.exists()) {
          const userData = snapshot.val();
          console.log("📊 Datos del usuario encontrados:", userData);
          console.log("🔑 isSuperAdmin value:", userData.isSuperAdmin);
          console.log("🔑 Tipo de isSuperAdmin:", typeof userData.isSuperAdmin);
          
          setDebugInfo({
            uid: user.uid,
            userData: userData,
            isSuperAdminValue: userData.isSuperAdmin,
            isSuperAdminType: typeof userData.isSuperAdmin,
            foundPath: `usuarios/${user.uid}`,
            authStatus: "Autenticado en Firebase"
          });

          // Verificación más permisiva
          const hasSuperAdmin = userData.isSuperAdmin === true || 
                               userData.isSuperAdmin === "true" || 
                               userData.isSuperAdmin === 1 ||
                               userData.isSuperAdmin === "1" ||
                               userData.isSuperAdmin === "yes" ||
                               userData.isSuperAdmin === "YES";
          
          console.log("✅ ¿Tiene Super Admin?", hasSuperAdmin);
          setIsSuperAdmin(hasSuperAdmin);
        } else {
          console.log("❌ Usuario no encontrado en usuarios/");
          
          // Intentar en BetPay como respaldo
          const betpayRef = ref(db, `BetPay/${user.uid}`);
          console.log(`🔍 Intentando en BetPay: BetPay/${user.uid}`);
          
          const betpaySnapshot = await get(betpayRef);
          
          if (betpaySnapshot.exists()) {
            const userData = betpaySnapshot.val();
            console.log("📊 Datos del usuario encontrados en BetPay:", userData);
            console.log("🔑 isSuperAdmin value:", userData.isSuperAdmin);
            
            setDebugInfo({
              uid: user.uid,
              userData: userData,
              isSuperAdminValue: userData.isSuperAdmin,
              isSuperAdminType: typeof userData.isSuperAdmin,
              foundPath: `BetPay/${user.uid}`,
              authStatus: "Autenticado en Firebase"
            });

            const hasSuperAdmin = userData.isSuperAdmin === true || 
                                 userData.isSuperAdmin === "true" || 
                                 userData.isSuperAdmin === 1 ||
                                 userData.isSuperAdmin === "1" ||
                                 userData.isSuperAdmin === "yes" ||
                                 userData.isSuperAdmin === "YES";
            
            console.log("✅ ¿Tiene Super Admin?", hasSuperAdmin);
            setIsSuperAdmin(hasSuperAdmin);
          } else {
            console.log("❌ Usuario no encontrado en ninguna ubicación");
            setDebugInfo({
              uid: user.uid,
              userData: null,
              isSuperAdminValue: null,
              isSuperAdminType: null,
              foundPath: null,
              authStatus: "Autenticado en Firebase pero no encontrado en DB"
            });
            setIsSuperAdmin(false);
          }
        }
      } catch (err) {
        console.error("❌ Error verificando super admin:", err);
        setError("Error al verificar permisos: " + err.message);
        setIsSuperAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkSuperAdminStatus();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400 mx-auto mb-4"></div>
          <p className="text-blue-200">Verificando permisos de administrador...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-red-900 to-slate-900">
        <div className="text-center">
          <div className="text-red-400 text-5xl mb-4">⚠️</div>
          <h2 className="text-xl font-bold text-white mb-2">Error de Acceso</h2>
          <p className="text-red-300 mb-4">{error}</p>
          {debugInfo && (
            <div className="bg-white/10 p-4 rounded-lg mb-4 text-left">
              <h3 className="text-white font-bold mb-2">Información de Depuración:</h3>
              <p className="text-white/80 text-sm">UID: {debugInfo.uid}</p>
              <p className="text-white/80 text-sm">isSuperAdmin: {String(debugInfo.isSuperAdminValue)}</p>
              <p className="text-white/80 text-sm">Tipo: {debugInfo.isSuperAdminType}</p>
              <p className="text-white/80 text-sm">Ruta encontrada: {debugInfo.foundPath}</p>
            </div>
          )}
          <button
            onClick={() => window.location.reload()}
            className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  if (!isSuperAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-red-900 to-slate-900">
        <div className="text-center">
          <div className="text-red-400 text-5xl mb-4">🚫</div>
          <h2 className="text-xl font-bold text-white mb-2">Acceso Denegado</h2>
          <p className="text-red-300 mb-4">
            No tienes permisos de Super Administrador para acceder a esta sección.
          </p>
          {debugInfo && (
            <div className="bg-white/10 p-4 rounded-lg mb-4 text-left max-w-md mx-auto">
              <h3 className="text-white font-bold mb-2">Información de Depuración:</h3>
              <p className="text-white/80 text-sm">UID: {debugInfo.uid}</p>
              <p className="text-white/80 text-sm">Estado de Auth: {debugInfo.authStatus}</p>
              <p className="text-white/80 text-sm">isSuperAdmin: {String(debugInfo.isSuperAdminValue)}</p>
              <p className="text-white/80 text-sm">Tipo: {debugInfo.isSuperAdminType}</p>
              <p className="text-white/80 text-sm">Ruta encontrada: {debugInfo.foundPath || 'No encontrado'}</p>
              <p className="text-white/80 text-sm">Usuario: {debugInfo.userData?.name || 'N/A'}</p>
              <p className="text-white/80 text-sm">Email: {debugInfo.userData?.email || 'N/A'}</p>
              <p className="text-white/80 text-sm">Tipo de cuenta: {debugInfo.userData?.tipoCuenta || 'N/A'}</p>
              <p className="text-white/80 text-sm">userUUID en localStorage: {localStorage.getItem("userUUID") || 'No encontrado'}</p>
              <p className="text-white/80 text-sm">uid en localStorage: {localStorage.getItem("uid") || 'No encontrado'}</p>
            </div>
          )}
          <button
            onClick={() => window.history.back()}
            className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
          >
            Volver
          </button>
        </div>
      </div>
    );
  }

  return Element;
};

SuperAdminRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default SuperAdminRoute; 